module.exports = __webpack_public_path__ + "img/iconservice.86b0e4fd.png";